import React from "react";
import Slider from "react-slick";
import {
  ChevronLeft as ICON_ARROW_LEFT,
  ChevronRight as ICON_ARROW_RIGHT,
} from "react-feather";

const makeSettings = (options) => {
  options = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    navigator: true,
    arrow: true,
    prevArrow: undefined,
    nextArrow: undefined,
    ...options,
  };

  const PrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style }}
        onClick={onClick}
      >
        {options.prevArrow ?? (
          <ICON_ARROW_LEFT color={"WHITE"} size={40} />
        )}
      </div>
    );
  };

  const NextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style }}
        onClick={onClick}
      >
        {options.nextArrow ?? (
          <ICON_ARROW_RIGHT color={"WHITE"} size={40} />
        )}
      </div>
    );
  };

  const settings = {
    dots: options.dots,
    infinite: options.infinite,
    speed: options.speed,
    slidesToShow: options.slidesToShow,
    slidesToScroll: options.slidesToScroll,
    navigator: options.navigator,
    arrow: options.arrow,

    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };
  return settings;
}

export {
  makeSettings,
};
export default Slider;